import React, { useEffect, useState } from "react";
import { SelectBox } from "devextreme-react/select-box";
import INTAKE_API from "api/intakeApi";
import MONITOR_API from "api/monitorApi";
import { useFetch } from "@hooks/useMonitorApi";

const BatchFilterDropdown = ({selectBatch, setSelectBatch, selectSupplier, setBatchData}) => {
  
  const { data: batches, isLoading: isBatchesLoading } = useFetch("getBatches", MONITOR_API.getMonitorBatches, { supplierId: selectSupplier });



    return (
      <React.Fragment>
        <div className='flex flex-col lg:flex-row sm:flex-row lg:items-center sm:items-center items-start'>
        
            <label className="text-sm me-2">Select Batch No</label>
            <SelectBox
                dataSource={batches?.data}
                displayExpr="batchNumber" // Display text
                valueExpr="batchNumber" // Value field
                value={selectBatch}
                searchEnabled={true}
                showClearButton={true}
                onValueChanged={(e) => {
                    setSelectBatch(e.value);
                    // localStorage.setItem("batchNum", e?.component?.option("text")); // Store supplier name in localStorage

                    const matchedBatch = batches?.data?.find(batch => batch.batchNumber === e.value);
                    console.log("matchedBatch", matchedBatch, e);
                    setBatchData(matchedBatch);
                    // if (matchedBatch) {
                    //   localStorage.setItem("selectedRow", JSON.stringify(matchedBatch));
                    // }
                }}
                placeholder="Select an option"
            />
        </div>
      </React.Fragment>
    );
  };
  
export default BatchFilterDropdown;
  
